export default {
    apiKey: "AIzaSyCkdazCNJbhYqvu1CpVnYVl0cwwIr_cF1E",
    authDomain: "hc-main-210517.firebaseapp.com",
    databaseURL: "https://hc-main-210517.firebaseio.com",
    projectId: "hc-main-210517",
    storageBucket: "hc-main-210517.appspot.com",
    messagingSenderId: "195547810479",
    appId: "1:195547810479:web:92de930f8abb9b7c4ee25a",
    measurementId: "G-K045QJ5DRB"
  };